/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import { createProfilePortfolioSnapshotHook } from '../../core/factories/createProfilePortfolioSnapshotHook.js';
import { type useGetProfilePortfolioSnapshotArgs, useGetProfilePortfolioSnapshotSpec } from '../specs/users.spec.gen.js';

export type { GetProfilePortfolioSnapshotRow } from '../openapi-types.gen.js';
export type { useGetProfilePortfolioSnapshotArgs } from '../specs/users.spec.gen.js';

/**
 * Live validated snapshot; the SDK owns its NATS handoff, replay, and reconciliation.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): userId.
 */
export const useGetProfilePortfolioSnapshot = createProfilePortfolioSnapshotHook(useGetProfilePortfolioSnapshotSpec);

/** Hover/intent prefetch companion for `useGetProfilePortfolioSnapshot`; same cache entry, no subscription. */
export const usePrefetchGetProfilePortfolioSnapshot = createPrefetchHook(useGetProfilePortfolioSnapshotSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetProfilePortfolioSnapshotArgs>;
